import { Link } from 'react-router-dom';

export default function Footer() {
  const appStoreUrl = 'https://apps.apple.com/us/app/i-say-i-am/id6762150286';

  return (
    <footer className="bg-[#222222] text-[#F5F5F5] py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Main Content */}
        <div className="flex flex-col items-center text-center mb-16">
          {/* Brand */}
          <h3 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Literata, serif' }}>
            I Say I Am
          </h3>
          <p className="text-lg text-[#F5F5F5]/70 mb-8 max-w-md leading-relaxed">
            Daily alignment, clarity and inner strength.
          </p>

          {/* Social Icons */}
          <div className="flex gap-4 mb-12">
            <a
              href="https://www.instagram.com/isayiam.app"
              aria-label="I Say I Am on Instagram"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all cursor-pointer"
            >
              <i className="ri-instagram-line text-xl text-[#F5F5F5]"></i>
            </a>
            <a
              href="https://www.tiktok.com/@isayiam.app"
              aria-label="I Say I Am on TikTok"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all cursor-pointer"
            >
              <i className="ri-tiktok-line text-xl text-[#F5F5F5]"></i>
            </a>
          </div>

          {/* Products Links */}
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-12">
            <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className="text-sm font-medium hover:text-white text-[#F5F5F5]/80 transition-colors cursor-pointer">
              Mobile App
            </a>
            <a href="#" className="text-sm font-medium hover:text-white text-[#F5F5F5]/80 transition-colors cursor-pointer">
              Audio Packs
            </a>
            <a href="#" className="text-sm font-medium hover:text-white text-[#F5F5F5]/80 transition-colors cursor-pointer">
              Printable Tools
            </a>
            <a href="https://www.amazon.com/dp/B0G6TM6JW3" target="_blank" rel="noopener noreferrer" className="text-sm font-medium hover:text-white text-[#F5F5F5]/80 transition-colors cursor-pointer">
              Daily Affirmations Book
            </a>
            <a href="https://www.amazon.com/dp/B0G6V4QDR1" target="_blank" rel="noopener noreferrer" className="text-sm font-medium hover:text-white text-[#F5F5F5]/80 transition-colors cursor-pointer">
              Gratitude Journal Book
            </a>
            <a href="https://www.amazon.com/dp/B0H1WLGSY6" target="_blank" rel="noopener noreferrer" className="text-sm font-medium hover:text-white text-[#F5F5F5]/80 transition-colors cursor-pointer">
              Reflections Journal Book
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#F5F5F5]/50">
            © 2025 I Say I Am. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-sm text-[#F5F5F5]/50 hover:text-[#F5F5F5] transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-sm text-[#F5F5F5]/50 hover:text-[#F5F5F5] transition-colors cursor-pointer">
              Terms of Service
            </Link>
            <Link to="/support" className="text-sm text-[#F5F5F5]/50 hover:text-[#F5F5F5] transition-colors cursor-pointer">
              Support
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
